import React, { memo } from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { numberFormat, colorFix, formatDate } from 'utils';
import FormSearchTradeHis from './layout/formSearchTradeHis';
import { makeGetAnalLichSuGia } from 'lib/selector';

import PerfectScrollbar from 'react-perfect-scrollbar';
import styled from 'styled-components';
import { _formatDate4 } from 'utils';

const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
    // border-collapse: separate;
  }

  table thead th {
    position: sticky;
    top: 0;
  }
  table.theme-light thead th {
    background: #666666;
  }
  table.theme-light thead th.highlight {
    background: #494757;
  }
  table thead th.sticky {
    top: 35px;
  }
  table thead th.bb-sticky {
    box-shadow: inset 0 -1px 0 #818181;
  }

  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
  table.theme-light.table-analysis tbody tr:nth-child(even) td.highlight {
    background: #cacaca;
  }
`;

const CardHeader = styled.div`
  background: ${props => props.theme === 'dark' ? 'var(--sub-nav)' : '#ffffff'};
  border-radius: 5px 5px 0px 0px;
  color: var(--half_white);
  font-size: 13px;
  padding: 0;
`;

function PanelTradeHistory(props) {
  const { symbol, analLichSuGia, t, theme } = props;

  // log(analLichSuGia);

  return (
    <Card
      className="w-100 mt-2"
      style={{ height: 'calc(100vh - 185px)', background: '#020210', borderRadius: '8px', }}
    >
      <CardHeader theme={theme}>
        <FormSearchTradeHis symbol={symbol} />
      </CardHeader>
      <Card.Body className="p-0">
        <PerfectScrollbar style={{ height: 'calc(100vh - 250px)' }}>
          <StyledDivTable>
            <table
              className={'table table-borderless table-analysis theme-' + theme}
            >
              <thead>
                <tr>
                  <th rowSpan={2} className="text-left">
                    {t('algo.ptcp.txt-Trade-date')}
                  </th>
                  <th rowSpan={2} className="text-right">
                    {t('algo.ptcp.txt-Close-price')}
                  </th>
                  <th rowSpan={2} className="text-right">
                    {t('algo.ptcp.txt-Change')}
                  </th>
                  <th rowSpan={2} className="text-right">
                    {t('algo.ptcp.txt-Ref-price')}
                  </th>
                  <th rowSpan={2} className="text-right">
                    {t('algo.ptcp.txt-Foreigner-buy-vol')}
                  </th>
                  <th rowSpan={2} className="text-right">
                    {t('algo.ptcp.txt-Proprietary-buy-vol')}
                  </th>
                  <th colSpan={2} className="bb-sticky highlight">
                    {t('algo.ptcp.txt-matched')}
                  </th>
                  <th colSpan={2} className="bb-sticky highlight">
                    {t('algo.ptcp.txt-put-through')}
                  </th>
                </tr>
                <tr>
                  <th className="text-right highlight sticky">
                    {t('algo.ptcp.txt-volume')}
                  </th>
                  <th className="text-right highlight sticky">
                    {t('algo.ptcp.txt-value')}
                  </th>
                  <th className="text-right highlight sticky">
                    {t('algo.ptcp.txt-volume')}
                  </th>
                  <th className="text-right highlight sticky">
                    {t('algo.ptcp.txt-value')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {analLichSuGia &&
                  analLichSuGia.map((item, index) => (
                    <tr key={index}>
                      <td className="txt-content">
                        {_formatDate4(item.TRADE_DATE)}
                      </td>
                      <td
                        className={
                          'text-right ' +
                          colorFix(
                            item.CLOSE_PRICE,
                            item.REF_PRICE,
                            item.CEILING_PRICE,
                            item.FLOOR_PRICE,
                            item.REF_PRICE
                          )
                        }
                      >
                        {numberFormat(item.CLOSE_PRICE / 1000, 2)}
                      </td>
                      <td
                        className={
                          'text-right ' +
                          (item.CLOSE_PRICE - item.REF_PRICE > 0 ? 'i' : item.CLOSE_PRICE - item.REF_PRICE < 0 ? 'd' : 'r')
                        }
                      >{`${numberFormat(
                        (item.CLOSE_PRICE - item.REF_PRICE) / 1000,
                        2,
                        '0'
                      )}`}</td>
                      <td className="text-right r">
                        {numberFormat(item.REF_PRICE / 1000, 2, '-')}
                      </td>
                      <td
                        className={
                          'text-right ' +
                          (item.F_NET_BUY_VOLUME > 0 ? 'i' : item.F_NET_BUY_VOLUME < 0 ? 'd' : 'txt-content')
                        }
                      >
                        {numberFormat(item.F_NET_BUY_VOLUME, 0, '0')}
                      </td>
                      <td
                        className={
                          'text-right ' + (item.PI_NET_BUY_VOL > 0 ? 'i' : item.PI_NET_BUY_VOL < 0 ? 'd' : 'txt-content')
                        }
                      >
                        {numberFormat(item.PI_NET_BUY_VOL, 0, '0')}
                      </td>
                      <td className="text-right txt-content highlight">
                        {numberFormat(item.TOT_VOLUME, 0, '0')}
                      </td>
                      <td className="text-right txt-content highlight">
                        {numberFormat(item.TOT_VALUE, 0, '0')}
                      </td>
                      <td className="text-right txt-content highlight">
                        {numberFormat(item.TOT_PT_VOLUME, 0, '0')}
                      </td>
                      <td className="text-right txt-content highlight">
                        {numberFormat(item.TOT_PT_VALUE, 0, '0')}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </StyledDivTable>
        </PerfectScrollbar>
      </Card.Body>
    </Card>
  );
}

const makeMapStateToProps = () => {
  const getAnalLichSuGia = makeGetAnalLichSuGia();

  const mapStateToProps = (state) => {
    return {
      analLichSuGia: getAnalLichSuGia(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(PanelTradeHistory));
